import { INotificationTypeDto } from 'api/api';
import { localizedDynamic } from 'state/i18n';

export const localizeNotificationTypeName = (notTypeDto: INotificationTypeDto) => {
	return localizedDynamic(
		notTypeDto.errorId !== null ? 'ErrorIds.' + notTypeDto.name : 'NotificationTypes.' + notTypeDto.name
	);
};
